import { Sparkles } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useLang, useSiteSettings } from "@/context/LanguageContext";

// Objekt gilt als „neu“, wenn es seit weniger als N Tagen online ist (Einstellung new_badge_days, 0 = aus)
export const isNewProperty = (p, days = 30) => {
  if (!p?.online_since || !(days > 0)) return false;
  const since = new Date(p.online_since);
  if (Number.isNaN(since.getTime())) return false;
  const age = (Date.now() - since.getTime()) / 86400000;
  return age >= 0 && age < days;
};

export const NewBadge = ({ property, className = "" }) => {
  const { lang, t } = useLang();
  const site = useSiteSettings();
  const days = site.new_badge_days ?? 30;
  if (!isNewProperty(property, Number(days))) return null;
  const date = new Date(property.online_since).toLocaleDateString(lang === "de" ? "de-DE" : lang);
  return (
    <Badge className={`bg-badge-new hover:bg-badge-new text-white text-[10px] uppercase tracking-wider gap-1 ${className}`} title={t.property.newBadgeHint.replace("{date}", date)} data-testid={`new-badge-${property.slug}`}>
      <Sparkles className="w-3 h-3" />{t.property.newBadge}
    </Badge>
  );
};
